import { render, staticRenderFns } from "./security_my_documents.vue?vue&type=template&id=31eb40d3&scoped=true"
import script from "./security_my_documents.vue?vue&type=script&lang=js"
export * from "./security_my_documents.vue?vue&type=script&lang=js"
import style0 from "./security_my_documents.vue?vue&type=style&index=0&id=31eb40d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31eb40d3",
  null
  
)

export default component.exports